import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const VideoModal = ({ isOpen, close }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={close}
      aria-labelledby="video-dialog-title"
      maxWidth="md"
      fullWidth 
      className='popup_video'
    >
      <IconButton
        aria-label="close"
        onClick={close}
        style={{ position: 'absolute', right: '8px', top: '8px' }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <video
          style={{ width: '100%' }} // Ensures that the video is responsive
          controls
          autoPlay
          loop
        >
          <source src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/byblaunchvideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
